import React, { FC, memo, useContext } from 'react'
import DynamicMarkdown from '../../app-components/dynamic-components/dynamic-markdown'

import { TipTransport } from '../../../transports/region-landing-page-transport'
import { TipCard, TipCardImage, TipCardContent, TipCardTitle, TipCardDescription, TipCardButton } from './styles'
import ImageLoadingComponent from '../../app-components/image-loading-component'
import { useTranslation } from '../../../hooks/locale'
import { ScreenContext } from 'react-components'

interface TipsSectionCardProps {
    tip: TipTransport
    location: string
}

const TipsSectionCard: FC<TipsSectionCardProps> = ({ tip }) => {
    const { t } = useTranslation()
    const { isMobile } = useContext(ScreenContext)
    if (!tip.image?.url) {
        return null
    }

    const imageUrl = (isMobile && tip.image?.formats?.small?.url) || tip.image?.formats?.large?.url || tip.image?.url

    return (
        <TipCard href={tip.cta?.url} target="_blank">
            <TipCardImage>
                <ImageLoadingComponent src={imageUrl} alt={tip.title} objectFit="cover" borderRadius="12px 12px 0 0" />
            </TipCardImage>
            <TipCardContent>
                <TipCardTitle>{tip.title}</TipCardTitle>
                <TipCardDescription>
                    <DynamicMarkdown>{tip.text}</DynamicMarkdown>
                </TipCardDescription>
                <TipCardButton>{t('tipsSectionButtonText')}</TipCardButton>
            </TipCardContent>
        </TipCard>
    )
}

export default memo(TipsSectionCard)
